module.exports = __webpack_public_path__ + "img/zzz.9fe6ff15.svg";